import CreateCollectionForm from './CreateCollectionForm';

export default CreateCollectionForm;



// WEBPACK FOOTER //
// ./src/scenes/Collections/components/CreateCollectionForm/index.ts